import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { Link, OverflowText } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import { SearchBox, useSearch } from "@transfr-inc/dashboard-components/forms";

import { createUserDetailLink } from "@lib/utils/navigation.utils";

import "./career-selected-users.list.scss";
import "./careers-selected.list.scss";

const getFullName = (user) => `${user.lastName}, ${user.firstName}`.trim();

export const CareerSelectedUsersList = ({
  data,
  classroom,
  breadcrumbLabel,
}) => {
  const [users, setUsers] = useState(data);
  const explorersSearch = useSearch({
    data: users,
    searchKeys: ["firstName", "lastName"],
  });

  const onExplorerTermChange = (term) => {
    const results = explorersSearch.queryData(term);
    setUsers(results);
  };

  const onExplorerSearchSelected = (explorer) => {
    setUsers([explorer]);
  };

  useEffect(() => {
    const results = explorersSearch.updateData(data);
    setUsers(results);
  }, [data]);

  return (
    <div className="career-selected-users-container">
      <h3>Selected by:</h3>
      <SearchBox
        disabled={!users}
        placeholder="Search"
        query={explorersSearch.queryData}
        onSearchTermChange={onExplorerTermChange}
        onResultSelected={onExplorerSearchSelected}
        customOptionLabel={getFullName}
      />
      <div className="careers-selected-list-container">
        <div>
          {users?.map((user) => {
            const fullName = getFullName(user);

            return (
              <Link
                routerComponent={NavLink}
                key={user.userId}
                to={createUserDetailLink({
                  userId: user.userId,
                  search: {
                    classroomId: classroom?.classroomId,
                    product: Product.TRK,
                    from: breadcrumbLabel,
                  },
                })}
                underline={false}
                className="user-item"
              >
                <div className="user-item-info">
                  <OverflowText className="main-title" text={fullName}>
                    {fullName}
                  </OverflowText>
                </div>
                <FontAwesomeIcon icon="fa-light fa-chevron-right" />
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};
